var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExportHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_export_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_export_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E5E5E5",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.000000, 4.000000)",
    fill: "#7D7D7D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,10 L14.5,10 C14.2333333,10 14,10.2526316 14,10.4736842 L14,13.6315789 C14,13.8842105 13.7666667,14.1052632 13.5,14.1052632 L2.5,14.1052632 C2.23333333,14.1052632 2,13.8842105 2,13.6315789 L2,10.4736842 C2,10.2526316 1.76666667,10 1.5,10 L0.5,10 C0.233333333,10 0,10.2526316 0,10.4736842 L0,14.7368421 C0,15.4315789 0.6,16 1.33333333,16 L14.6666667,16 C15.4,16 16,15.4315789 16,14.7368421 L16,10.4736842 C16,10.2526316 15.7666667,10 15.5,10 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35,0.150208623 C8.15,-0.050069541 7.85,-0.050069541 7.65,0.150208623 L3.15,4.65646732 C2.95,4.85674548 2.95,5.15716273 3.15,5.35744089 L3.85,6.05841446 C4.05,6.25869263 4.35,6.25869263 4.55,6.05841446 L6.41666667,4.1891516 C6.61666667,3.98887344 7.01666667,4.12239221 7.01666667,4.42280946 L7.01666667,11.4993046 C7.01666667,11.7663421 7.21666667,12 7.48333333,12 L8.48333333,12 C8.75,12 9.01666667,11.7329624 9.01666667,11.4993046 L9.01666667,4.45618915 C9.01666667,4.15577191 9.35,4.02225313 9.58333333,4.22253129 L11.45,6.09179416 C11.65,6.29207232 11.95,6.29207232 12.15,6.09179416 L12.85,5.39082058 C13.05,5.19054242 13.05,4.89012517 12.85,4.68984701 L8.35,0.150208623 L8.35,0.150208623 Z",
    id: "Path"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExportHover);
export default __webpack_public_path__ + "static/media/icon_export_hover.eafb3985fd005ff93a48ce3f9be7d78a.svg";
export { ForwardRef as ReactComponent };